import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-pfeil-extern",
  "use": "various-pfeil-extern-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-pfeil-extern\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M25.399 7.778l-15.617.06-.01 2.698 12.918-.05-.049 12.92 2.698-.011z\" /><path d=\"M22.452 8.375l2.121 2.12-14.849 14.85-2.121-2.121z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol